import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
declare var webkitSpeechRecognition: any;
@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  recognition: any;
  isStoppedSpeechRecog = false;
  public text = '';
  private voiceToTextSubject: Subject<string> = new Subject();
  private speakingPaused: Subject<any> = new Subject();
  private tempWords: string = '';

  private chatbotVisible = new BehaviorSubject<boolean>(false);
  chatbotVisible$ = this.chatbotVisible.asObservable();

  toggleChatbotVisibility() {
    this.chatbotVisible.next(!this.chatbotVisible.value);
  }

  setChatbotVisibility(visible: boolean) {
    this.chatbotVisible.next(visible);
  }
  constructor() { }
  speechInput() {
    return this.voiceToTextSubject.asObservable();
  }
  init() {
    this.recognition = new webkitSpeechRecognition();
    this.recognition.interimResults = true;
    this.recognition.lang = 'en-US';

    this.recognition.addEventListener('result', (e: any) => {
      const transcript = Array.from(e.results)
        .map((result: any) => result[0])
        .map((result) => result.transcript)
        .join('');
      this.tempWords = transcript;
      this.voiceToTextSubject.next(this.text || transcript);
    });
    return this.initListeners();
  }

  /**
   * @description Add event listeners to get the updated input and when stoped
   */
  initListeners() {
    this.recognition.addEventListener('end', (condition: any) => {
      this.recognition.stop();
    });
    return this.speakingPaused.asObservable();
  }

  /**
   * @description Function to mic on to listen.
   */
  start() {
    // Reset text and flags
    this.text = '';
    this.isStoppedSpeechRecog = false;

    // Check if recognition is already running, and only start if it's not
    if (this.recognitionIsActive()) {
      console.log("Speech recognition is already running. No need to start again.");
      return;
    }

    // Start recognition and set the flag
    this.recognition.start();
    this.recognition.isRecognitionActive = true;

    // Cleanup existing event listeners to avoid duplicate ones
    this.cleanupRecognitionListeners();

    // Handle the recognition result
    let silenceTimeout: any;
    this.recognition.addEventListener('result', (event: any) => {
      clearTimeout(silenceTimeout); // Reset the silence timer on each new speech result
      silenceTimeout = setTimeout(() => {
        this.stopRecording(); // Stop recording after 3 seconds of silence
      }, 3000); // 3 seconds of silence
    });

    // Handle recognition end event
    this.recognition.addEventListener('end', () => {
      this.recognition.isRecognitionActive = false; // Reset the flag when recognition ends

      if (this.isStoppedSpeechRecog) {
        this.recognition.stop();
      } else {
        this.wordConcat();

        // Restart recognition if the last active time was more than 200ms ago
        if (!this.recognition.lastActive || (Date.now() - this.recognition.lastActive) > 200) {
          this.recognition.start();
          this.recognition.lastActive = Date.now();
          this.recognition.isRecognitionActive = true;
        }
      }

      // Push the recognized text to a subject for other listeners
      this.voiceToTextSubject.next(this.text);
    });
  }

  // Utility method to check if recognition is active
  recognitionIsActive(): boolean {
    return this.recognition.isRecognitionActive || false;
  }

  // Utility method to clean up event listeners to prevent multiple listeners
  cleanupRecognitionListeners() {
    this.recognition.removeEventListener('result', () => { });
    this.recognition.removeEventListener('end', () => { });
  }

  // stopRecording() stays as it is


  /**
   * @description Function to stop recognition.
   * 
   */
  private isRecordingSubject = new BehaviorSubject<boolean>(false);
  public isRecording$ = this.isRecordingSubject.asObservable();
  stopRecording() {
    this.isStoppedSpeechRecog = true;
    this.recognition.stop();
    this.isRecordingSubject.next(false);
  }
  getMicStatus() {
    return this.isRecordingSubject.value;
  }
  stop() {
    this.text = '';
    this.isStoppedSpeechRecog = true;
    this.wordConcat()
    this.recognition.stop();
    this.recognition.isActive = false;
    this.speakingPaused.next('Stopped speaking');
  }

  /**
   * @description Merge previous input with latest input.
   */
  wordConcat() {
    this.text = this.text.trim() + ' ' + this.tempWords;
    this.text = this.text.trim();
    this.tempWords = '';
  }
}
